module.exports = __webpack_public_path__ + "assets/img/e2cdce558ddb80e54d882c616dd85cf9.svg";